/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { connect } from 'react-redux';
import GrayPanel from "../../components/GrayPanel";
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';

import { DecisionContainer, PersonalDataContainer } from "../../containers";
import history from "../../core/history";
import { runService } from '../../actions/eservices';
import CustomizedMap from "./CustomizedMap";
import pans from "./panStyle.scss";
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import { trackEvent } from '../../lib/utils';
import ButtonsPanel from './utils/ButtonsPanel';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import { bodyStyle, redirectToSummary } from './constants';
import { showDraftsCondition, saveDraft, areEqual, getDraft, getDraftDataFromState } from '../../components/DraftManagement/draftManager';


import v from './validators';


const AddressFormDict = {
  AddressCity: {
    label: "Miejscowość",
    editable: true
  },
  AddressStreet: {
    label: "Ulica",
    editable: true
  },
  AddressFlat: {
    label: "Numer lokalu",
    editable: true
  },
  AddressNumber: {
    label: "Numer budynku",
    editable: true
  },
  AddressZipCode: {
    label: "Kod pocztowy",
    editable: true
  }
};

const AddressFormDict2 = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  cel: {
    label: 'Zaświadczenie niezbędne jest w celu',
    editable: true,
    type: 'textarea',
  },
};

const AddressFormDict3 = {
  AddressCity: {
    label: 'Miejscowość:',
    editable: true,
  },
  cel: {
    label: 'Niniejsze zaświadczenie przedłożę w:',
    editable: true,
    type: 'textarea',
  },
};

const stateToDraft = [
  "AddressFormDict",
  "selectedParcels",
  "selectedRoads",
];


class ZaswiadczenieEMUIA extends React.Component {
  state = {
    AddressFormDict: {
      AddressCity: null,
      AddressStreet: null,
      AddressFlat: null,
      AddressNumber: null,
      AddressZipCode: null,
      cel: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    isMounted: false,
  };

  validators = {
    AddressCity: [v.NotNull],
    AddressStreet: [],
    AddressNumber: [v.NotNull],
    AddressFlat: [v.isStrictInteger],
    AddressZipCode: [v.NotNull],
    cel: [],
  }

  async componentDidMount() {
    const showDrafts = showDraftsCondition(this.props.prefix);
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          showDrafts: showDrafts,
        });
      });

    if (['gmina_olesno_powiat_oleski', 'gmina_janowiec'].includes(this.props.prefix)) {
      this.validators.AddressCity = [v.NotNull];
      this.validators.AddressStreet = [];
      this.validators.AddressFlat = [];
      this.validators.AddressNumber = [];
      this.validators.AddressZipCode = [];
      this.validators.cel = [v.NotNull];
    }

    if (showDrafts) {
      const draftData = await getDraft(this.props.prefix, this.props.serviceInfo.eservice.shortName);

      if (draftData) {
        this.setState({ ...draftData, draftAttachments: draftData.attachments, isMounted: true }, () => {
          window.dispatchEvent(
            new CustomEvent("draft:loaded")
          );
        });
      } else {
        this.setState({ isMounted: true });
      }
    } else {
      this.setState({
        isMounted: true
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDrafts) {
      if (!this.state.isMounted) return;

      if (!prevState.isMounted && this.state.isMounted) return;

      const prevDraft = getDraftDataFromState(prevState, stateToDraft);
      const currentDraft = getDraftDataFromState(this.state, stateToDraft);

      if (this.props.serviceInfo.user && !areEqual(prevDraft, currentDraft)) {
        saveDraft(
          currentDraft,
          this.props.prefix,
          this.props.serviceInfo.eservice.shortName
        );
      }
    }
  }

  handleManualDraftSave = () => {
    const draft = getDraftDataFromState(this.state, stateToDraft);

    saveDraft(
      draft,
      this.props.prefix,
      this.props.serviceInfo.eservice.shortName,
      { debounce: false } // wymuszony zapis
    );
  };

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) =>
    this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState({
      [group]: {
        ...this.state[group],
        [name]: e.target.value,
      }
    }, () => this.validate(group, name));
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (let validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  }

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          }
        };
      }
    } else {
      const fields = Object.keys(this.state[group]);
      const errors = {};
      for (let f of fields) {
        const checks = this.validateField(group, f);
        errors[f] = checks;
      }
      newState = { errors: errors };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  }

  haseErrors = () => {
    for (let key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  }

  insertTestData = () => this.setState({
    AddressFormDict: {
      AddressCity: 'Pielgrzymka',
      AddressStreet: 'nowogrodzka',
      AddressFlat: 8,
      AddressNumber: 5,
      AddressZipCode: '02-787',
      cel: 'cel testowy',
    },
  })

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: "Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki",
        errorTitle: "Błędnie wypełniony formularz",
        showError: true,
      });
      return;
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }
    
    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props.runService(
        this.props.serviceInfo.eservice.shortName,
        this.props.district,
        {
          AddressFormDict: { ...this.state.AddressFormDict },
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix]
        },
      )
      .then(resp => {
        trackEvent({
          category: 'application',
          action: 'click',
          name: this.props.serviceInfo.eservice.title,
        });
        redirectToSummary(resp.jobId);
      });
    }
  }

  startService = () => {
    this.validate("AddressFormDict", null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);

    if (!this.state.isMounted) {
      return (
        <GrayPanel
          title="Trwa ładowanie zawartości..."
          bodyStyle={bodyStyle}
        >
          <img alt="Loader" src={waiting} />
        </GrayPanel>
      );
    }

    return (
      <div style={{ paddingTop: "20px" }}>
        <h3 style={{ textAlign: "center" }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>

        {!['gmina_janowiec', 'gmina_olesno_powiat_oleski'].includes(this.props.prefix) && 
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.AddressFormDict}
            errors={this.state.errors}
            formDict={AddressFormDict}
            onChange={e => this.onChange(e, 'AddressFormDict')}
          />
        }

        {['gmina_olesno_powiat_oleski'].includes(this.props.prefix) && 
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.AddressFormDict}
            errors={this.state.errors}
            formDict={AddressFormDict2}
            onChange={e => this.onChange(e, 'AddressFormDict')}
          />
        }

        {['gmina_janowiec'].includes(this.props.prefix) && 
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.AddressFormDict}
            errors={this.state.errors}
            formDict={AddressFormDict3}
            onChange={e => this.onChange(e, 'AddressFormDict')}
          />
        }

        <GrayPanel title={"Podstawa prawna:"}>
          <p style={{ textAlign: "justify" }}>
            Zgodnie z załącznikiem do Ustawy z dnia 16 listopada 2006 r. o
            opłacie skarbowej (j.t. Dz. U. z 2016, poz. 1827 z późn. zm.) za
            pozostałe świadczenia pobierana jest opłata skarbowa w wysokości 17
            zł.
          </p>
        </GrayPanel>

        {/* BUTTONS */}
        <ButtonsPanel
          prefix={this.props.prefix}
          shortName={this.props.serviceInfo.eservice.shortName}
          serviceTitle={this.props.serviceInfo.eservice.title}
          showDrafts={this.state.showDrafts}
          onDraftSave={this.handleManualDraftSave}
          onSave={() => this.startService()}
          onCancel={history.goBack}
        />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}


ZaswiadczenieEMUIA.contextTypes = {
  fontSizeScale: React.PropTypes.number,
};

const mapState = (state) => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(connect(mapState, mapDispatch)(ZaswiadczenieEMUIA));



// WEBPACK FOOTER //
// src/routes/eservices/ZaswiadczenieEMUIA.js